import React from 'react';
import './loader.css'; // Import the loader CSS file

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
